import { Injectable, inject } from '@angular/core';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

export type ModalState = {
  isOpen: boolean;
  id: string;
  messages: any[];
};

@Injectable()
export class ModalService {

  private modalService = inject(NgbModal);

  public open(content: any, options?: NgbModalOptions): NgbModalRef {
    const defaultOptions: NgbModalOptions = {
      backdrop: 'static',
      backdropClass: 'modal-background',
      keyboard: false
    };
    options = { ...defaultOptions, ...options }
    return this.modalService.open(content, options);
  }

  dismissAll() {
    this.modalService.dismissAll();
  }

  hasOpenModals(): boolean {
    return this.modalService.hasOpenModals();
  }
}
